import { Injectable } from '@angular/core';
import { INGXLoggerMetadata, NGXLoggerServerService } from 'ngx-logger';
import packageInfo from '../../package.json';

@Injectable()
export class CustomizedServerLogService extends NGXLoggerServerService {
  /**
   * Customize the log information that is sent to the log API endpoint.
   * The default data is extended by the user ID and the current URL.
   *
   * @param metadata - The data provided by `NGXLogger`
   * @returns Customized data
   */
  public customiseRequestBody(metadata: INGXLoggerMetadata): any {
    const body = {
      ...metadata,
      userId: (window as any).DEP_LOG_USER_ID,
      url: window.location.href,
      frontendVersion: packageInfo.version,
    };

    return body;
  }
}
